import { z } from 'zod';
import { ConversationIdSchema, RunIdSchema } from './ids.ts';

export const RUN_STATUSES = ['active', 'completed', 'stopped', 'failed', 'interrupted'] as const;
export const RunStatusSchema = z.enum(RUN_STATUSES);
export type RunStatus = z.infer<typeof RunStatusSchema>;

export const TERMINAL_RUN_STATUSES: readonly RunStatus[] = [
  'completed',
  'stopped',
  'failed',
  'interrupted',
];

export const RUN_STOP_REASONS = [
  'finished',
  'step_limit',
  'token_budget',
  'timeout',
  'context_budget',
  'stopped_by_user',
  'authorization_expired',
  'shutdown',
  'error',
] as const;
export const RunStopReasonSchema = z.enum(RUN_STOP_REASONS);
export type RunStopReason = z.infer<typeof RunStopReasonSchema>;

export const RunUsageSchema = z.object({
  inputTokens: z.number().int().nonnegative(),
  outputTokens: z.number().int().nonnegative(),
  cacheReadTokens: z.number().int().nonnegative(),
  cacheWriteTokens: z.number().int().nonnegative(),
  steps: z.number().int().nonnegative(),
  toolCalls: z.number().int().nonnegative().optional(),
  webSearches: z.number().int().nonnegative().optional(),
  sandboxMs: z.number().int().nonnegative().optional(),
  costMicroUsd: z.number().int().nonnegative().optional(),
  creditMicros: z.number().int().nonnegative().optional(),
  pricingVersion: z.string().min(1).max(64).optional(),
});
export type RunUsage = z.infer<typeof RunUsageSchema>;

export const RUN_PURPOSES = ['chat', 'eval', 'preview', 'scheduled'] as const;
export const RunPurposeSchema = z.enum(RUN_PURPOSES);
export type RunPurpose = z.infer<typeof RunPurposeSchema>;

export const RunEventSchema = z.object({
  run_id: RunIdSchema,
  conversation_id: ConversationIdSchema,
  seq: z.number().int().positive(),
  chunk: z.looseObject({ type: z.string() }),
  created_at: z.string(),
});
export type RunEvent = z.infer<typeof RunEventSchema>;

export const SSE_DONE = '[DONE]';

export const SSE_KEEPALIVE_COMMENT = ': keepalive\n\n';
export const SSE_KEEPALIVE_INTERVAL_MS = 15_000;

export function encodeSseData(chunk: unknown): string {
  return `data: ${JSON.stringify(chunk)}\n\n`;
}
